export const frequencyType = Object.freeze({
  day: "dia",
  days: "dias",
  month: "mes",
  months: "meses",
  year: "año",
  years: "años",
});
